import { Node } from "@tiptap/core";
import { mergeAttributes } from "@tiptap/core";

export const PageBreak = Node.create({
    name: "pageBreak",
    group: "block",
    isLeaf: true,
    selectable: false,

    parseHTML() {
        return [
            {
                tag: "div[data-type='page-break']",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-type": "page-break",
                class: "page-break",
            }),
        ];
    },
});
